import React from 'react';

const ContactCTA = ({ title, description, phoneNumber = '+15715826010', phoneDisplay = '(571) 582-6010' }) => {
  return (
    <section className="py-12 bg-gradient-to-br from-gray-900 via-onyx-900 to-gray-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
          {title}
        </h2>
        <p className="text-lg sm:text-xl text-gray-300 leading-relaxed mb-10">
          {description}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="mailto:info@onyxroseadvisors.com"
            className="inline-block bg-accent text-white font-semibold px-10 py-4 rounded-md hover:bg-accent-900 transition-all duration-200 shadow-lg hover:shadow-xl text-lg"
          >
            Email Us
          </a>
          <a
            href={`tel:${phoneNumber}`}
            className="inline-block bg-white text-accent border-2 border-white font-semibold px-10 py-4 rounded-md hover:bg-gray-100 transition-all duration-200 shadow-lg hover:shadow-xl text-lg"
          >
            Call {phoneDisplay}
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactCTA;
